import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { PairBoostersBadge } from '@root/entities/pair/ui'
import { PairTicker } from '@root/entities/pair/ui/common'
import { PairAuditBadge } from '@root/entities/pair/ui/pair-information/pair-audit-badge'
import { PairRank } from '@root/entities/pair/ui/pair-rank'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const PairExploreItemHeading: React.FC<Props> = ({ pair }) => {
  const [rank] = useAtom(pair.rank)

  return (
    <Root>
      <Ticker pair={pair} />
      <PairRank rank={rank} />
      <PairBoostersBadge
        currency={pair.quote}
        premiumInfo={pair.premiumInfo}
        mode="explore"
      />
      <PairAuditBadge pair={pair} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;

  align-items: center;
  justify-content: start;

  gap: 6px;
`

const Ticker = styled(PairTicker)`
  font-size: 14px;
  font-weight: 600;
  line-height: 115%;
  letter-spacing: 0.48px;
`
